import moment from 'moment';

export var EXTRAS_FILTERS_KEY = 'financeiro.extras';

// Defaults depend on "today", so they are built at mount (usePersistedFilters).
// The period is kept as day strings because DateNavigation also allows a custom range.
export var getDefaultExtrasFilters = function() {
  return {
    from: moment().startOf('month').format('YYYY-MM-DD'),
    to: moment().endOf('month').format('YYYY-MM-DD'),
    extraStatus: 'revised',
    statusFilters: [],
    originFilters: [],
    search: '',
  };
};

// Turns the saved filter into the /extras/payments params (period only; the
// rest is filtered client-side).
export var getExtrasRequest = function(filters) {
  return {
    filter_by: 'due_date',
    from: filters.from,
    to: filters.to,
    status: 'all',
  };
};

export var isExtrasPeriodDefault = function(filters, defaults) {
  return filters.from === defaults.from && filters.to === defaults.to;
};

// Converts a DateNavigation month ('YYYY-MM') into the saved period.
export var getMonthPeriod = function(month) {
  var m = moment(month, 'YYYY-MM');
  return {
    from: m.clone().startOf('month').format('YYYY-MM-DD'),
    to: m.clone().endOf('month').format('YYYY-MM-DD'),
  };
};

export var getExtrasPeriodLabel = function(filters) {
  var fromDate = moment(filters.from, 'YYYY-MM-DD');
  var toDate = moment(filters.to, 'YYYY-MM-DD');
  var firstMonth = fromDate.format('MMM/YYYY');
  var lastMonth = toDate.format('MMM/YYYY');
  var wholeMonths = fromDate.date() === 1 && toDate.isSame(toDate.clone().endOf('month'), 'day');
  if (!wholeMonths) return 'Período: ' + fromDate.format('DD/MM/YYYY') + ' – ' + toDate.format('DD/MM/YYYY');
  if (firstMonth === lastMonth) return 'Mês: ' + firstMonth;
  return 'Período: ' + firstMonth + ' – ' + lastMonth;
};

// Badge: only what differs from the defaults (each status/origin counts once).
export var countActiveExtrasFilters = function(filters, defaults) {
  return (isExtrasPeriodDefault(filters, defaults) ? 0 : 1) +
    (filters.extraStatus !== defaults.extraStatus ? 1 : 0) +
    (filters.statusFilters || []).length +
    (filters.originFilters || []).length +
    (filters.search ? 1 : 0);
};
